export default __webpack_public_path__ + "static/media/cancel.9ca0233a.svg";